import { cn } from "@/lib/utils";

/**
 * The 16px square indicator used by the flow's choice lists, per the design's
 * 2px white outline.
 *
 * Checked state draws a tick rather than filling the box solid — a filled
 * square reads as "blocked out" more than "chosen".
 *
 * Expects to sit after a `peer`-classed input so it can show a focus ring for
 * keyboard users.
 */
export function ChoiceBox({ selected }: { selected: boolean }) {
  return (
    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded peer-focus-visible:ring-2 peer-focus-visible:ring-white/60">
      <span
        className={cn(
          "relative flex h-4 w-4 items-center justify-center outline outline-2 -outline-offset-1 outline-white",
        )}
      >
        {selected && (
          <svg viewBox="0 0 16 16" className="h-[14px] w-[14px]" aria-hidden="true">
            <path
              d="M3 8.4l3.2 3.2L13 4.6"
              fill="none"
              stroke="#ffffff"
              strokeWidth="2.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
    </span>
  );
}
